<div class="leverage-products mt-2">
  <ng-container *ngIf="isChangingUnderlying; else products">
    <leverage-products-underlying-search (underlyingSelected)="underlyingSelected($event)" />
  </ng-container>
  <ng-template #products>
    <h3 class="font-medium">
      <ng-container *ngIf="isStandalone; else simpleHeader">
        <ng-container *ngIf="facade.currentDerivativeType$ | async as currentDerivativeType">
          {{ 'leverage-products.header.' + currentDerivativeType | transloco: { name: assetName } }}
        </ng-container>
        <svg class="icon icon-24 cursor-pointer color-secondary" (click)="isChangingUnderlying = true">
          <use xlink:href="/assets/img/svgs/svgset.svg#editPencil" />
        </svg>
      </ng-container>
      <ng-template #simpleHeader>
        {{ 'leverage-products.header.simple' | transloco: { name: assetName } }}
      </ng-template>
    </h3>

    <leverage-products-derivative-search-navigation
      [isCustomLeverageSelected]="editLeverage"
      [preselectedInvestmentType]="investmentType"
    />
    <leverage-products-derivative-search-list [products]="facade.products$ | async" />
  </ng-template>
</div>
